import { type ReactElement, useState } from 'react';
import { SearchField, type SearchFieldComponentProps } from '#components/search-field/search-field';
import { useSearchDebounce } from '#hooks/use-search-debounce';

interface SearchFieldWithDebounceProps extends SearchFieldComponentProps {
  timeout?: number;
}
export function SearchFieldWithDebounce({
  value,
  timeout = 500,
  onChange,
  showLoading = false,
  ...props
}: SearchFieldWithDebounceProps): ReactElement {
  const [isLoading, setIsLoading] = useState(false);

  const { localValue, setLocalValue } = useSearchDebounce({
    value,
    onChange: v => {
      setIsLoading(false);
      onChange?.(v);
    },
    timeout,
  });

  return (
    <SearchField
      {...props}
      onChange={val => {
        setLocalValue(val);
        if (showLoading) {
          setIsLoading(true);
        }
      }}
      showLoading={isLoading}
      value={localValue}
    />
  );
}
